<template>
  <el-button
      @click="$emit('click', site)"
      class="my-1 w-100 justify-content-start"
      :class="[getButtonClass, additionalClasses]"
      :type="getButtonType"
      plain
  >
    <div>
      <fa
          class="headquarter fa-xl mr-2"
          icon="star"
          v-if="site.isHeadquarter"
      />
      <span class="font-weight-bolder">{{ siteName }} - </span>
      <span class="font-weight-bolder">{{ site.registrationId }} </span>
      <span> - {{ siteAddress }} </span>
    </div>
    <div v-if="site.leaseboardSimulation">
      <fa
          class="fa-xl ml-3"
          icon="folder-open"
      />
      <span class="font-weight-bolder ml-1">{{ site.leaseboardSimulation }}</span>
    </div>

  </el-button>
</template>

<script>
export default {
  name: 'SiteButton',
  props: {
    site: {
      type: Object,
      required: true
    },
    additionalClasses: {
      type: String,
      default: ''
    }
  },
  emits: ['click'],
  methods: {
    formatAddress(address) {
      return `${address.houseNumber || ''} ${address.street} ${address.zipCode} ${address.locality}`.trim();
    }
  },
  computed: {
    siteName() {
      return this.site.names?.[0]?.name || this.site.names?.[0]?.commercialName || 'NOM INDISPONIBLE';
    },
    siteAddress() {
      const address = this.site.addresses?.[0]
          || (this.site.isHeadquarter && this.site.headquarterAddresses?.[0]);

      return address ? this.formatAddress(address) : "ADRESSE INDISPONIBLE";
    },
    getButtonType() {
      return this.site?.status === 'AC' ? 'primary' : 'danger';
    },
    getButtonClass() {
      return this.additionalClasses;
    }
  }
};
</script>

<style scoped>
.headquarter {
  color: gold;
}
</style>